<template>
  <a-modal
    :visible="visible"
    title=""
    ok-text="确认"
    cancel-text="取消"
    class="modal-confirm"
    :confirmLoading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="modal-confirm-container">
      <div class="modal-confirm-content-title">
        {{ title }}
      </div>
      <div class="modal-confirm-content-content">
        {{ content }}
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    loading: {
      require: true,
      type: Boolean,
      default: false
    },
    visible: {
      require: true,
      type: Boolean
    },
    title: {
      require: false,
      type: String,
      default: "提示"
    },
    content: {
      require: false,
      type: String,
      default: ""
    },
    handleOk: {
      require: true,
      type: Function
    },
    handleCancel: {
      require: true,
      type: Function
    }
  }
};
</script>

<style lang="less">
.modal-confirm {
  .ant-modal-footer {
    border-top: 0;
  }

  .ant-modal-header {
    border-bottom: 0;
  }

  .modal-confirm-container {
    padding: 20px;
    .modal-confirm-content-title {
      font-size: 19px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .modal-confirm-content-content {
      font-size: 16px;
      font-weight: 400;
    }
  }
}
</style>
